<div
  class="flex w-full min-h-0 flex-1 flex-col items-center px-container-padding-mobile py-4 md:px-container-padding-desktop"
>
  <div class="mx-auto flex w-full max-w-6xl min-h-0 flex-1 flex-col gap-3">
    <!-- Theme Header -->
    <div class="relative flex w-full items-center justify-center">
  <!-- Tema centralizado exatamente no meio da tela (padding lateral reserva espaço do botão "Desistir") -->
  <h2 class="neon-glow-pink px-14 text-center font-headline-lg text-headline-lg text-primary sm:px-36 md:font-display-xl-mobile md:text-display-xl-mobile">
    {{ theme() }}
  </h2>

  <!-- Desistir: só com a partida em andamento -->
  @if (gameResult() === null) {
    <div class="absolute right-0 top-1/2 -translate-y-1/2">
      <button
        type="button"
        aria-label="Desistir da partida"
        class="active-press flex cursor-pointer items-center gap-2 rounded-full border-2 border-outline-variant bg-transparent p-2 font-label-mono text-label-mono uppercase text-on-surface-variant transition-colors duration-150 hover:border-danger hover:bg-danger/10 hover:text-danger disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-outline-variant disabled:hover:bg-transparent disabled:hover:text-on-surface-variant sm:px-4"
        [disabled]="isInputDisabled()"
        (click)="onGiveUpClick()"
      >
        @if (isGivingUp()) {
          <app-spinner />
        } @else {
          <span class="material-symbols-outlined text-xl leading-none">flag</span>
        }
        <span class="hidden sm:inline">Desistir</span>
      </button>
    </div>
  }
</div>

   <!-- History Area -->
<div
  class="question grid min-h-0 flex-1 auto-rows-min grid-cols-1 gap-1.5 overflow-y-auto overflow-x-clip rounded-xl border border-white/10 bg-surface-container p-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.4)] md:grid-cols-2 md:gap-x-4 md:gap-y-1.5"
>
@if (history().length === 0 && !hasPendingInteraction()) {
  <div class="col-span-full flex flex-1 flex-col items-center justify-center gap-4 py-8 text-center text-on-surface-variant">
    @if (instructions().length > 0) {
      <div class="flex w-full max-w-xl flex-col gap-3 text-left">
        <div class="flex items-center justify-center gap-2 text-secondary">
          <span class="material-symbols-outlined text-2xl">menu_book</span>
          <h3 class="font-label-mono text-sm font-bold uppercase tracking-widest">Instruções</h3>
        </div>
        <ol class="flex list-decimal flex-col gap-1.5 pl-6 font-game-question text-sm leading-snug marker:font-label-mono marker:text-secondary">
          @for (instruction of instructions(); track $index) {
            <li>{{ instruction }}</li>
          }
        </ol>
      </div>
    }
    <p class="font-game-question text-lg font-bold text-on-surface md:text-xl">
      Faça uma pergunta para começar
    </p>
  </div>
} @else {
  @for (item of history(); track $index) {
    <!-- Palpites (type = Guess) usam um fundo levemente mais claro que as perguntas -->
    <div
      class="flex min-w-0 flex-col gap-1.5 rounded-md border border-white/5 px-3 py-1.5 md:flex-row md:items-center md:justify-between md:gap-3"
      [class.bg-surface-variant]="item.type !== InteractionType.Guess"
      [class.bg-surface-bright]="item.type === InteractionType.Guess"
    >

      <p class="font-game-question text-xs leading-snug text-on-surface break-words min-w-0 flex-1 m-0">
        {{ item.userText }}
      </p>

      <!-- Status com respiro confortável entre ícone e texto -->
      @if (item.answerCode === AnswerCode.Yes || item.answerCode === AnswerCode.CorrectGuess) {
        <span class="flex shrink-0 items-center gap-1.5 self-start rounded-full bg-success/10 px-2.5 py-1 font-label-mono text-xs leading-none text-on-surface md:self-auto">
          <span class="material-symbols-outlined text-sm leading-none flex items-center justify-center">check</span>Sim
        </span>
      } @else if (item.answerCode === AnswerCode.No || item.answerCode === AnswerCode.WrongGuess) {
        <span class="flex shrink-0 items-center gap-1.5 self-start rounded-full bg-danger/10 px-2.5 py-1 font-label-mono text-xs leading-none text-on-surface md:self-auto">
          <span class="material-symbols-outlined text-sm leading-none flex items-center justify-center">close</span>Não
        </span>
      } @else if (item.answerCode === AnswerCode.Invalid) {
        <app-tooltip [text]="getInvalidAnswerMessage(item)">
          <span class="flex shrink-0 cursor-help items-center gap-1.5 self-start rounded-full bg-tertiary/10 px-2.5 py-1 font-label-mono text-xs leading-none text-on-surface md:self-auto">
            <span class="material-symbols-outlined text-sm leading-none flex items-center justify-center">warning</span>Inválido
          </span>
        </app-tooltip>
      }

    </div>
  }
  @if (pendingText(); as pending) {
    <div class="flex min-w-0 flex-col gap-1.5 rounded-md border border-white/5 bg-surface-variant px-3 py-1.5 md:flex-row md:items-center md:justify-between md:gap-3">

      <p class="font-game-question text-xs leading-snug text-on-surface break-words min-w-0 flex-1 m-0">
        {{ pending }}
      </p>

      <span class="flex shrink-0 items-center gap-1.5 self-start rounded-full bg-white/10 px-2.5 py-1 font-label-mono text-xs leading-none text-on-surface md:self-auto">
        <app-spinner />Pensando...
      </span>

    </div>
  }
}
</div>

    <!-- Input Area -->
    <form
      class="mx-auto flex w-full shrink-0 max-w-4xl items-center gap-3"
      (submit)="onSubmitInteraction($event, questionInput)"
    >
      <input
        #questionInput
        class="min-w-0 flex-grow rounded-full border border-outline/30 bg-surface-variant px-6 py-3 font-game-answer text-body-md text-on-surface placeholder:text-on-surface-variant focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary disabled:cursor-not-allowed disabled:opacity-50"
        [placeholder]="isQuestionLimitReached() ? 'Faça seu palpite...' : 'Faça uma pergunta ou palpite...'"
        type="text"
        [disabled]="isInputDisabled()"
      />

      <app-tooltip text="Enviar">
        <button
          class="active-press flex cursor-pointer items-center justify-center rounded-full bg-tertiary p-3 text-on-tertiary drop-shadow-[0_0_8px_rgba(233,196,0,0.4)] transition-transform hover:scale-105 disabled:cursor-not-allowed disabled:opacity-50"
          type="submit"
          [disabled]="isInputDisabled()"
        >
          <span class="material-symbols-outlined">send</span>
        </button>
      </app-tooltip>

      <!-- Contadores: perguntas e palpites (limites vindos da API) -->
      <div class="flex shrink-0 flex-col gap-1 font-label-mono text-xs leading-none text-on-surface-variant/70">
        <span
          class="flex items-center gap-1"
          [class.text-danger]="isQuestionLimitReached()"
          [attr.aria-label]="'Perguntas: ' + questionsCount() + ' de ' + (maxQuestions() ?? '–')"
        >
          <span class="material-symbols-outlined text-sm leading-none text-tertiary">help</span>
          <span class="hidden sm:inline">Perguntas</span>
          {{ questionsCount() }}/{{ maxQuestions() ?? '–' }}
        </span>
        <span class="flex items-center gap-1" [attr.aria-label]="'Palpites: ' + guessCount() + ' de ' + (guessLimit() ?? '–')">
          <span class="material-symbols-outlined text-sm leading-none text-primary">lightbulb</span>
          <span class="hidden sm:inline">Palpites</span>
          {{ guessCount() }}/{{ guessLimit() ?? '–' }}
        </span>
      </div>
    </form>
  </div>
</div>

<app-wrong-guess-toast [visible]="showWrongGuessToast()" />

@if (gameResult(); as result) {
  <app-game-result-modal
    [variant]="result"
    [characterName]="characterName()"
    (playAgain)="onPlayAgain()"
    (backToHome)="onBackToHome()"
  />
}

@if (showGiveUpConfirm()) {
  <app-confirm-modal
    message="Tem certeza que deseja desistir da partida?"
    (confirm)="onConfirmGiveUp()"
    (cancel)="onCancelGiveUp()"
    (close)="onCancelGiveUp()"
  />
}

@if (errorAlert(); as alert) {
  <app-alert-modal [message]="alert.message" (close)="onCloseErrorAlert()" />
}
